import React, { useCallback, useEffect, useMemo, useState } from 'react';

import Grid from '@material-ui/core/Grid';
import { MdDeviceUnknown, MdSensors } from 'react-icons/md';
import { RiUserSearchFill } from 'react-icons/ri';
import { TiDownload } from 'react-icons/ti';

import { AxiosError } from 'axios';
import { IMessage, useAuth } from '../../../../hooks/auth';
import { useSelectInfo } from '../../../../hooks/selectInfo';

import { useToast } from '../../../../hooks/toast';

import api from '../../../../services/api';

import PageTitle from '../../../../components/PageTitle';
import LineGraph from './LinearGraph';

import { Advice } from '../../../../components/Advice';
import { IDevice, ISensor } from '../../../../interfaces';
import DownloadCSV from '../../components/DownloadCSV';
import DownloadDeviceExcel from '../../components/DownloadDevicesExcel';
import * as S from './styles';
import { SelectDevice } from './styles';


const Dashboard: React.FC = () => {
  const { selectedSensorId, selectSensor, selectUser, selectedUser, selectedIndicator, selectIndicator } = useSelectInfo();
  const { user } = useAuth();
  const { addToast } = useToast();

  const [selectedDeviceName, setSelectedDeviceName] = useState('');
  const [selectedDeviceId, setSelectedDeviceId] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [showDownloadData, setShowDownloadData] = useState(false);
  const [showDeviceDownloadData, setDeviceDownloadData] = useState(false);

  const [sensorList, setSensorList] = useState<ISensor[]>([] as ISensor[]);
  const [messages, setMessages] = useState<IMessage[]>([]);
  const [allDevices, setAllDevices] = useState<IDevice[]>([] as IDevice[]);

  const selectedSensor = useMemo(() => sensorList.find(sensor => sensor.id === selectedSensorId), [selectedSensorId]);

  
  const isAdmin: boolean = useMemo(() => {
    if (user.sysadmin || user.permissions?.includes("|level-admin|")) return true;

    return false;
  }, [user]);

  const isManager: boolean = useMemo(() => {
    if (user.sysadmin || user.permissions?.includes("|level-manager|")) return true;

    return false;
  }, [user]);

  const shouldShowAllDevices = useMemo(() => {
    return isAdmin && selectedUser?.name === 'Administrador';
  }, [isAdmin, selectedUser?.name]);

  const fetchAllDevices = useCallback(async () => {
    try {
      const { data } = await api.get<IDevice[] | IDevice>('devices');

      if (Array.isArray(data)) {
        setAllDevices(data);
        return;
      }

      setAllDevices(data ? [data] : []);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Erro ao buscar dispositivos',
        description: (error as AxiosError).response ? `${(error as AxiosError).response?.data.message}` : `${error}`,
      });
    }
  }, [addToast]);

  const getUserProfile = useCallback(async () => {
    
    try {
      let client_id = user.client_id;
      const { data } = await api.get('profiles', { params: { client_id } });
      
      if (data.length > 0) 
        selectUser(data[0]);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Erro ao buscar perfil',
        description: (error as AxiosError).response ? `${(error as AxiosError).response?.data.message}` : `${error}`,
      });
    }
  }, [user]);
  
  useEffect(() => {
    selectIndicator('');
    selectSensor('');
    setSelectedDeviceName('')
    if (!isAdmin && !isManager && !selectedUser?.id) 
      getUserProfile();
    

    if (!selectedUser?.messages || selectedUser.messages?.length === 0) {
      setShowMessage(false);
      setMessages([]);
      return;
    }

    const notReadedMessages = selectedUser.messages?.filter(message => message.not_readed);

    setMessages([...notReadedMessages]);
  }, [selectedUser, isAdmin, isManager]);

  useEffect(() => {
    if (shouldShowAllDevices) {
      fetchAllDevices();
    }
  }, [fetchAllDevices, shouldShowAllDevices]);

  const searchDeviceHandle = useCallback(async () => {
    if (!selectedDeviceName) return;

    try {
      const { data } = await api.get<IDevice>('devices', { params: { name: selectedDeviceName } });
 
      if (Array.isArray(data)) {
        setSelectedDeviceId(data[0]?.id || '');
        setSensorList(data[0]?.sensors || []);
      } else {
        setSelectedDeviceId(data?.id || '');
        setSensorList(data?.sensors || []);
      }
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Erro ao buscar dispositivo',
        description: (error as AxiosError).response ? `${(error as AxiosError).response?.data.message}` : `${error}`,
      });
    }
  }, [addToast, selectedDeviceName, setSensorList]);

  useEffect(() => {
    if (selectedDeviceName) {
      searchDeviceHandle();
    }
  }, [selectedDeviceName, searchDeviceHandle]);

  const devicesForList = useMemo(() => {
    if (shouldShowAllDevices) return allDevices;

    return selectedUser.devices || [];
  }, [allDevices, selectedUser.devices, shouldShowAllDevices]);

  useEffect(() => {
    setSensorList([...[]]);
    selectSensor('');

    if (devicesForList.length === 1) {
      setSelectedDeviceName(devicesForList[0].name);
      return;
    }

    setSelectedDeviceName('');
  }, [devicesForList, selectSensor]);

  const selectDevice = (deviceId: string) => {
    setSelectedDeviceName(deviceId);
  };

  const devicesList = useMemo(() => {
    return (
      <ul className="devicesList">
        <div>
          <div>
            <h3>Dispositivo</h3>
            <SelectDevice
              onChange={e => {
                selectSensor('');
                selectDevice(e.target.value);
              }}
              value={selectedDeviceName}
            >
              <option value={undefined}>Selecione um dispositivo</option>
              {devicesForList.map(device => (
                <option key={device.name} value={device.name}>
                  {device.name}
                </option>
              ))}
            </SelectDevice>
                          {/* {selectedSensorId && (
                <button type="button" className="exportButton" onClick={() => setShowDownloadData(true)}>
                  <TiDownload size="1.2em" />
                </button>
              )} */}
          </div>
          <S.Devbar>
            {/* {!isAdmin && (
              <button type="button" className="sendMessageButton" onClick={() => setShowMessage(true)}>
                Mensagem
              </button>
            )}

            {messages?.length > 0 && isAdmin && (
              <button type="button" className="viewMessageButton" onClick={() => setShowMessage(true)}>
                <MdEmail />
              </button>
            )} */}

            <div className="sendMessageButton">
              {/* {selectedSensorId && (
                <button type="button" className="sendMessageButton" onClick={() => setShowDownloadData(true)}>
                  <TiDownload size="1.5em" />
                </button>
              )} */}
            </div>
            <S.SensorActions>
              {selectedDeviceId && (
                <button type="button" className="exportButton" title="Exportar dados do dispositivo" onClick={() => setDeviceDownloadData(true)}>
                  <TiDownload size="1.2em" />
                </button>
              )}
            </S.SensorActions>
            <S.Sensorlist>
              {sensorList.map(({ id, name }) => (
                <button
                  type="button"
                  key={id}
                  onClick={() => {
                    selectSensor(id); // Seleciona o sensor
                  }}
                  className={selectedSensorId === id ? 'active' : ''}
                >
                  {name}
                </button>
              ))}
            </S.Sensorlist>
          </S.Devbar>
        </div>
      </ul>
    );
  }, [devicesForList, selectSensor, selectedDeviceName, selectedSensorId, selectedDeviceId, selectedUser, sensorList, messages, selectedIndicator]);

  const nonExistentDeviceMessage = useMemo(() => {
    if (!isAdmin) return 'Nenhum dispositivo foi atribuído a você';

    if (selectedUser?.id) return 'Atribua um dispositivo para esse usuário';

    return 'Selecione um usuário';
  }, [selectedUser, isAdmin]);

  const nonExistentDeviceIcon = useMemo(() => {
    if (!isAdmin) return MdDeviceUnknown;

    if (selectedUser?.id) return MdDeviceUnknown;

    return RiUserSearchFill;
  }, [selectedUser, isAdmin]);

  return (
    <S.DashboardWrapper>
      <PageTitle sub={`Dashboard ${isAdmin && selectedUser?.client?.name ? `de ${selectedUser?.client?.name}` : ''}`} title="Controle" />
      {/* Removed the old charts and restructured the dashboard */}
      <S.Container>
        <Grid container style={{ overflow: 'visible' }} spacing={3}>
          {devicesForList.length > 0 ? (
            <>
              <Grid item xs={12}>
                {devicesList}
              </Grid>
              {/* Renderiza o gráfico apenas se um sensor estiver selecionado */}
              {selectedDeviceName ? (
                (selectedSensorId) ? (
                  <S.Graph>
                    {selectedSensorId && <LineGraph selectedSensor={selectedSensor} />}
                  </S.Graph>
                ) : (
                  <Grid item xs={12}>
                    <Advice text={'Selecione um Sensor'} icon={MdSensors} />
                  </Grid>
                )
              ) : (
                <Grid item xs={12}>
                  <Advice text={'Selecione um dispositivo'} icon={MdSensors} />
                </Grid>
              )}
            </>
          ) : (
            <Grid item xs={12}>
              <Advice text={nonExistentDeviceMessage} icon={nonExistentDeviceIcon} />
            </Grid>
          )}
        </Grid>
        
        {/* <Message messages={messages} setMessages={setMessages} show={showMessage} closeFunction={setShowMessage} /> */}
        <DownloadCSV show={showDownloadData} closeFunction={setShowDownloadData} sensorId={selectedSensorId} csvUrl="sensorCSVData" />
        <DownloadDeviceExcel show={showDeviceDownloadData} closeFunction={setDeviceDownloadData} deviceId={selectedDeviceId} url="devices/export-excel-with-sensorsdata" />
      </S.Container>
    </S.DashboardWrapper>
  );
};

export default Dashboard;
